<button
  class="cta-badge"
  [ngClass]="[color(), size(), isIconOnly() ? 'icon-only' : '']"
  [class.highlighted]="highlighted()"
  [class.disabled]="isDisabled()"
  [attr.aria-label]="ariaLabel() ?? text()"
  [disabled]="isDisabled()"
  (click)="onClick()"
>
  @if (icon()) {
    <ptl-icon [icon]="icon()" [size]="'xs'"></ptl-icon>
  }

  <span class="button-text" *ngIf="text()" [innerHTML]="text()"></span>

  <ng-content></ng-content>

  @if (iconSuffix()) {
    <ptl-icon [icon]="iconSuffix()" [size]="'xs'"></ptl-icon>
  }
</button>
